import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { fnSave } from "@shared/api/restApi";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { useNavigate } from "react-router-dom";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_QMS_REQ_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();

  const searchRef = useRef<any>(null);
  const formControlDataRef = useRef<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchForm();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_qms_req_rep_001_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
  };
  const onGrid2BtnClick = async (id: string) => {
    try {
      if (id === "btn_lot") {
        const grid1 = gridRefs.current["grid1"].current;
        const grid2 = gridRefs.current["grid2"].current;

        const selectedHeader = grid1.getSelectedRows();
        const selectedLines = grid2.getSelectedRows();

        if (!selectedHeader || selectedHeader.length === 0) {
          await showDialog("alter", "상단 데이터를 선택하세요.");
          return;
        }

        if (!selectedLines || selectedLines.length === 0) {
          await showDialog("alter", "하단 데이터를 선택하세요.");
          return;
        }
        const hasInvalid = selectedLines.some((row: any) => row.st_qc !== "P");

        if (hasInvalid) {
          await showDialog("alter", "의뢰 상태가 아닙니다.");
          return;
        }

        // 🔥 메뉴 정보 가져오기
        const menuItems = useMenuStore.getState().menuItems;

        const drillDown = menuItems?.find(
          (item: any) => item?.cd_menu === "SN_QMS_REQ_REG_001"
        );

        if (!drillDown) {
          await showDialog("error", "LOT 할당 메뉴를 찾을 수 없습니다.");
          return;
        }

        // 🔥 전달 데이터 구성
        const header = selectedHeader[0];

        const lineData = selectedLines.map((row: any) => ({
          // 검사구분은 qms_req PK 구성요소라 원본 행의 값을 그대로 넘겨야 한다.
          fg_insp: row.fg_insp,
          dt_req: row.dt_req,
          nm_cd_req: row.nm_cd_req,
          no_req: row.no_req,
          no_line_req: row.no_line_req,
          qt_req: row.qt_req,
          qt_qc: row.qt_qc,
          qt_qc_good: row.qt_qc_good,
          qt_qc_bad: row.qt_qc_bad,
        }));

        const returnData = {
          header,
          lines: lineData,
        };

        // 🔥 화면 경로 생성
        const filePath =
          `./${drillDown.cd_module}/${drillDown.cd_menu}/${drillDown.cd_menu}`.toUpperCase();

        // 🔥 핵심: 다른 화면 호출
        (window as any).onActivate(
          drillDown.cd_menu,
          drillDown.nm_menu,
          drillDown.cd_module,
          filePath,
          drillDown,
          drillDown.nm_path,
          returnData, // 👈 여기로 데이터 전달됨
          "fg_drilldown.Registration"
        );
      }
    } catch (error: any) {
      await showDialog("error", error.message);
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const cd_item = selectedRow.cd_item;
      gridRefs.current["grid2"].current.applyFilters({
        cd_item: cd_item,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChanged2,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex w-full h-full min-w-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="25.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "품목정보",
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="74%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "의뢰정보",
            }}
            events={grids.grid2.events}
            header={
              <div>
                <SnButton
                  text={"검사LOT할당"}
                  onClick={() => {
                    onGrid2BtnClick("btn_lot");
                  }}
                />
                <SnButton
                  text={"약식성적서작성"}
                  onClick={() => {
                    onGrid2BtnClick("btn_report");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_QMS_REQ_REP_001;
